function Error() {
    return (
        <main>
            <h1>404</h1>
        </main>
    );
}

export default Error;